import {Box, SvgIcon, SvgIconProps} from "@mui/material";

export interface TrainIconProps extends SvgIconProps {
    scolor?: string;
}

const TrainIcon = ({scolor = "#78909C", ...props}: TrainIconProps) => {
    return (
        <SvgIcon style={{fill: "none", pointerEvents: "all"}}

                 {...props} >
            <defs>
                <filter id="a" width="28.118" height="30" x="0" y="0" colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feOffset dy="4" in="SourceAlpha"/>
                    <feMorphology radius="2"/>
                    <feOffset dy="-2"/>
                    <feGaussianBlur stdDeviation="1.333"/>
                    <feColorMatrix values="0 0 0 0 0.956863 0 0 0 0 0.262745 0 0 0 0 0.211765 0 0 0 0.2 0"/>
                    <feBlend in2="BackgroundImageFix" result="effect_dropShadow_1"/>
                    <feOffset dy="4" in="SourceAlpha"/>
                    <feMorphology radius="1"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feColorMatrix values="0 0 0 0 0.956863 0 0 0 0 0.262745 0 0 0 0 0.211765 0 0 0 0.2 0"/>
                    <feBlend in2="effect_dropShadow_1" result="effect_dropShadow_2"/>
                    <feBlend in="SourceGraphic" in2="effect_dropShadow_2" result="shape"/>
                </filter>
            </defs>
            <path d="M1.757 0h20.486v18.58H1.757V0"/>
            <g filter="url(#a)" transform="scale(1.15) translate(-2, 0)"><Box strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7"
                                     d="m12.803 3.871-7.682 8.516h5.975v5.42l7.682-8.517h-5.975z" component="path"
                                     sx={{
                                         stroke: scolor,
                                         '&:hover': {
                                             stroke: 'white', // Background color on hover
                                         },
                                     }}/></g>
        </SvgIcon>
    );
};

export default TrainIcon;